import PaymentDataModal from 'components/orders/PaymentDataModal/styled';

export default PaymentDataModal;
